/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateRoleRequestDto } from '../models';
// @ts-ignore
import type { ReplaceRolePermissionsRequestDto } from '../models';
// @ts-ignore
import type { RoleDetailsDto } from '../models';
// @ts-ignore
import type { RoleDto } from '../models';
// @ts-ignore
import type { RoleErrorResponseDto } from '../models';
// @ts-ignore
import type { UpdateRoleRequestDto } from '../models';
/**
 * RestRolesApi - axios parameter creator
 */
export const RestRolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Requires ROLE_CREATE; giving the new role permissions additionally requires ROLE_EDIT. 400 codes: ROLE_NAME_REQUIRED, ROLE_NAME_TOO_LONG, ROLE_HIERARCHY_LEVEL_OUT_OF_RANGE, ROLE_PERMISSION_UNKNOWN. 409 codes: ROLE_NAME_TAKEN.
         * @summary Create a role with its permissions
         * @param {CreateRoleRequestDto} createRoleRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole: async (createRoleRequestDto: CreateRoleRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRoleRequestDto' is not null or undefined
            assertParamExists('createRole', 'createRoleRequestDto', createRoleRequestDto)
            const localVarPath = `/api/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRoleRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires ROLE_DELETE. System roles and roles held by users cannot be deleted. 409 codes: SYSTEM_ROLE_NOT_DELETABLE, ROLE_ASSIGNED_TO_USERS.
         * @summary Delete a custom role
         * @param {string} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole: async (roleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('deleteRole', 'roleId', roleId)
            const localVarPath = `/api/roles/{roleId}`
                .replace('{roleId}', encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires ROLE_READ.
         * @summary Get a role with its permissions and the number of users holding it
         * @param {string} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole: async (roleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('getRole', 'roleId', roleId)
            const localVarPath = `/api/roles/{roleId}`
                .replace('{roleId}', encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires ROLE_EDIT. The Administrator role always keeps ROLE_READ and ROLE_EDIT. 400 codes: ROLE_PERMISSIONS_REQUIRED, ROLE_PERMISSION_UNKNOWN. 409 codes: ADMIN_ROLE_PERMISSIONS_LOCKED.
         * @summary Replace the permissions of a role
         * @param {string} roleId 
         * @param {ReplaceRolePermissionsRequestDto} replaceRolePermissionsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceRolePermissions: async (roleId: string, replaceRolePermissionsRequestDto: ReplaceRolePermissionsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('replaceRolePermissions', 'roleId', roleId)
            // verify required parameter 'replaceRolePermissionsRequestDto' is not null or undefined
            assertParamExists('replaceRolePermissions', 'replaceRolePermissionsRequestDto', replaceRolePermissionsRequestDto)
            const localVarPath = `/api/roles/{roleId}/permissions`
                .replace('{roleId}', encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceRolePermissionsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires ROLE_EDIT. The given fields are saved in one transaction: either all of them or none. The name of a system role cannot be changed, and the Administrator role always keeps ROLE_READ and ROLE_EDIT. 400 codes: ROLE_NAME_REQUIRED, ROLE_NAME_TOO_LONG, ROLE_HIERARCHY_LEVEL_OUT_OF_RANGE, ROLE_PERMISSION_UNKNOWN. 409 codes: ROLE_NAME_TAKEN, SYSTEM_ROLE_NAME_LOCKED, ADMIN_ROLE_PERMISSIONS_LOCKED.
         * @summary Change the name, the hierarchy level and/or the permission set of a role
         * @param {string} roleId 
         * @param {UpdateRoleRequestDto} updateRoleRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole: async (roleId: string, updateRoleRequestDto: UpdateRoleRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('updateRole', 'roleId', roleId)
            // verify required parameter 'updateRoleRequestDto' is not null or undefined
            assertParamExists('updateRole', 'updateRoleRequestDto', updateRoleRequestDto)
            const localVarPath = `/api/roles/{roleId}`
                .replace('{roleId}', encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRoleRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestRolesApi - functional programming interface
 */
export const RestRolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestRolesApiAxiosParamCreator(configuration)
    return {
        /**
         * Requires ROLE_CREATE; giving the new role permissions additionally requires ROLE_EDIT. 400 codes: ROLE_NAME_REQUIRED, ROLE_NAME_TOO_LONG, ROLE_HIERARCHY_LEVEL_OUT_OF_RANGE, ROLE_PERMISSION_UNKNOWN. 409 codes: ROLE_NAME_TAKEN.
         * @summary Create a role with its permissions
         * @param {CreateRoleRequestDto} createRoleRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRole(createRoleRequestDto: CreateRoleRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRole(createRoleRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestRolesApi.createRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires ROLE_DELETE. System roles and roles held by users cannot be deleted. 409 codes: SYSTEM_ROLE_NOT_DELETABLE, ROLE_ASSIGNED_TO_USERS.
         * @summary Delete a custom role
         * @param {string} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRole(roleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRole(roleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestRolesApi.deleteRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires ROLE_READ.
         * @summary Get a role with its permissions and the number of users holding it
         * @param {string} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRole(roleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRole(roleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestRolesApi.getRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestRolesApi.getRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires ROLE_EDIT. The Administrator role always keeps ROLE_READ and ROLE_EDIT. 400 codes: ROLE_PERMISSIONS_REQUIRED, ROLE_PERMISSION_UNKNOWN. 409 codes: ADMIN_ROLE_PERMISSIONS_LOCKED.
         * @summary Replace the permissions of a role
         * @param {string} roleId 
         * @param {ReplaceRolePermissionsRequestDto} replaceRolePermissionsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceRolePermissions(roleId: string, replaceRolePermissionsRequestDto: ReplaceRolePermissionsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceRolePermissions(roleId, replaceRolePermissionsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestRolesApi.replaceRolePermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires ROLE_EDIT. The given fields are saved in one transaction: either all of them or none. The name of a system role cannot be changed, and the Administrator role always keeps ROLE_READ and ROLE_EDIT. 400 codes: ROLE_NAME_REQUIRED, ROLE_NAME_TOO_LONG, ROLE_HIERARCHY_LEVEL_OUT_OF_RANGE, ROLE_PERMISSION_UNKNOWN. 409 codes: ROLE_NAME_TAKEN, SYSTEM_ROLE_NAME_LOCKED, ADMIN_ROLE_PERMISSIONS_LOCKED.
         * @summary Change the name, the hierarchy level and/or the permission set of a role
         * @param {string} roleId 
         * @param {UpdateRoleRequestDto} updateRoleRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRole(roleId: string, updateRoleRequestDto: UpdateRoleRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRole(roleId, updateRoleRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestRolesApi.updateRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestRolesApi - factory interface
 */
export const RestRolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestRolesApiFp(configuration)
    return {
        /**
         * Requires ROLE_CREATE; giving the new role permissions additionally requires ROLE_EDIT. 400 codes: ROLE_NAME_REQUIRED, ROLE_NAME_TOO_LONG, ROLE_HIERARCHY_LEVEL_OUT_OF_RANGE, ROLE_PERMISSION_UNKNOWN. 409 codes: ROLE_NAME_TAKEN.
         * @summary Create a role with its permissions
         * @param {CreateRoleRequestDto} createRoleRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole(createRoleRequestDto: CreateRoleRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RoleDetailsDto> {
            return localVarFp.createRole(createRoleRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires ROLE_DELETE. System roles and roles held by users cannot be deleted. 409 codes: SYSTEM_ROLE_NOT_DELETABLE, ROLE_ASSIGNED_TO_USERS.
         * @summary Delete a custom role
         * @param {string} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole(roleId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteRole(roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires ROLE_READ.
         * @summary Get a role with its permissions and the number of users holding it
         * @param {string} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole(roleId: string, options?: RawAxiosRequestConfig): AxiosPromise<RoleDetailsDto> {
            return localVarFp.getRole(roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles(options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleDto>> {
            return localVarFp.getRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * Requires ROLE_EDIT. The Administrator role always keeps ROLE_READ and ROLE_EDIT. 400 codes: ROLE_PERMISSIONS_REQUIRED, ROLE_PERMISSION_UNKNOWN. 409 codes: ADMIN_ROLE_PERMISSIONS_LOCKED.
         * @summary Replace the permissions of a role
         * @param {string} roleId 
         * @param {ReplaceRolePermissionsRequestDto} replaceRolePermissionsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceRolePermissions(roleId: string, replaceRolePermissionsRequestDto: ReplaceRolePermissionsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RoleDetailsDto> {
            return localVarFp.replaceRolePermissions(roleId, replaceRolePermissionsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires ROLE_EDIT. The given fields are saved in one transaction: either all of them or none. The name of a system role cannot be changed, and the Administrator role always keeps ROLE_READ and ROLE_EDIT. 400 codes: ROLE_NAME_REQUIRED, ROLE_NAME_TOO_LONG, ROLE_HIERARCHY_LEVEL_OUT_OF_RANGE, ROLE_PERMISSION_UNKNOWN. 409 codes: ROLE_NAME_TAKEN, SYSTEM_ROLE_NAME_LOCKED, ADMIN_ROLE_PERMISSIONS_LOCKED.
         * @summary Change the name, the hierarchy level and/or the permission set of a role
         * @param {string} roleId 
         * @param {UpdateRoleRequestDto} updateRoleRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole(roleId: string, updateRoleRequestDto: UpdateRoleRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RoleDetailsDto> {
            return localVarFp.updateRole(roleId, updateRoleRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestRolesApi - interface
 */
export interface RestRolesApiInterface {
    /**
     * Requires ROLE_CREATE; giving the new role permissions additionally requires ROLE_EDIT. 400 codes: ROLE_NAME_REQUIRED, ROLE_NAME_TOO_LONG, ROLE_HIERARCHY_LEVEL_OUT_OF_RANGE, ROLE_PERMISSION_UNKNOWN. 409 codes: ROLE_NAME_TAKEN.
     * @summary Create a role with its permissions
     * @param {CreateRoleRequestDto} createRoleRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRole(createRoleRequestDto: CreateRoleRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RoleDetailsDto>;

    /**
     * Requires ROLE_DELETE. System roles and roles held by users cannot be deleted. 409 codes: SYSTEM_ROLE_NOT_DELETABLE, ROLE_ASSIGNED_TO_USERS.
     * @summary Delete a custom role
     * @param {string} roleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteRole(roleId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Requires ROLE_READ.
     * @summary Get a role with its permissions and the number of users holding it
     * @param {string} roleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRole(roleId: string, options?: RawAxiosRequestConfig): AxiosPromise<RoleDetailsDto>;

    /**
     * 
     * @summary Get roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoles(options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleDto>>;

    /**
     * Requires ROLE_EDIT. The Administrator role always keeps ROLE_READ and ROLE_EDIT. 400 codes: ROLE_PERMISSIONS_REQUIRED, ROLE_PERMISSION_UNKNOWN. 409 codes: ADMIN_ROLE_PERMISSIONS_LOCKED.
     * @summary Replace the permissions of a role
     * @param {string} roleId 
     * @param {ReplaceRolePermissionsRequestDto} replaceRolePermissionsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    replaceRolePermissions(roleId: string, replaceRolePermissionsRequestDto: ReplaceRolePermissionsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RoleDetailsDto>;

    /**
     * Requires ROLE_EDIT. The given fields are saved in one transaction: either all of them or none. The name of a system role cannot be changed, and the Administrator role always keeps ROLE_READ and ROLE_EDIT. 400 codes: ROLE_NAME_REQUIRED, ROLE_NAME_TOO_LONG, ROLE_HIERARCHY_LEVEL_OUT_OF_RANGE, ROLE_PERMISSION_UNKNOWN. 409 codes: ROLE_NAME_TAKEN, SYSTEM_ROLE_NAME_LOCKED, ADMIN_ROLE_PERMISSIONS_LOCKED.
     * @summary Change the name, the hierarchy level and/or the permission set of a role
     * @param {string} roleId 
     * @param {UpdateRoleRequestDto} updateRoleRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRole(roleId: string, updateRoleRequestDto: UpdateRoleRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RoleDetailsDto>;

}

/**
 * RestRolesApi - object-oriented interface
 */
export class RestRolesApi extends BaseAPI implements RestRolesApiInterface {
    /**
     * Requires ROLE_CREATE; giving the new role permissions additionally requires ROLE_EDIT. 400 codes: ROLE_NAME_REQUIRED, ROLE_NAME_TOO_LONG, ROLE_HIERARCHY_LEVEL_OUT_OF_RANGE, ROLE_PERMISSION_UNKNOWN. 409 codes: ROLE_NAME_TAKEN.
     * @summary Create a role with its permissions
     * @param {CreateRoleRequestDto} createRoleRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createRole(createRoleRequestDto: CreateRoleRequestDto, options?: RawAxiosRequestConfig) {
        return RestRolesApiFp(this.configuration).createRole(createRoleRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires ROLE_DELETE. System roles and roles held by users cannot be deleted. 409 codes: SYSTEM_ROLE_NOT_DELETABLE, ROLE_ASSIGNED_TO_USERS.
     * @summary Delete a custom role
     * @param {string} roleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteRole(roleId: string, options?: RawAxiosRequestConfig) {
        return RestRolesApiFp(this.configuration).deleteRole(roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires ROLE_READ.
     * @summary Get a role with its permissions and the number of users holding it
     * @param {string} roleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRole(roleId: string, options?: RawAxiosRequestConfig) {
        return RestRolesApiFp(this.configuration).getRole(roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRoles(options?: RawAxiosRequestConfig) {
        return RestRolesApiFp(this.configuration).getRoles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires ROLE_EDIT. The Administrator role always keeps ROLE_READ and ROLE_EDIT. 400 codes: ROLE_PERMISSIONS_REQUIRED, ROLE_PERMISSION_UNKNOWN. 409 codes: ADMIN_ROLE_PERMISSIONS_LOCKED.
     * @summary Replace the permissions of a role
     * @param {string} roleId 
     * @param {ReplaceRolePermissionsRequestDto} replaceRolePermissionsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public replaceRolePermissions(roleId: string, replaceRolePermissionsRequestDto: ReplaceRolePermissionsRequestDto, options?: RawAxiosRequestConfig) {
        return RestRolesApiFp(this.configuration).replaceRolePermissions(roleId, replaceRolePermissionsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires ROLE_EDIT. The given fields are saved in one transaction: either all of them or none. The name of a system role cannot be changed, and the Administrator role always keeps ROLE_READ and ROLE_EDIT. 400 codes: ROLE_NAME_REQUIRED, ROLE_NAME_TOO_LONG, ROLE_HIERARCHY_LEVEL_OUT_OF_RANGE, ROLE_PERMISSION_UNKNOWN. 409 codes: ROLE_NAME_TAKEN, SYSTEM_ROLE_NAME_LOCKED, ADMIN_ROLE_PERMISSIONS_LOCKED.
     * @summary Change the name, the hierarchy level and/or the permission set of a role
     * @param {string} roleId 
     * @param {UpdateRoleRequestDto} updateRoleRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateRole(roleId: string, updateRoleRequestDto: UpdateRoleRequestDto, options?: RawAxiosRequestConfig) {
        return RestRolesApiFp(this.configuration).updateRole(roleId, updateRoleRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

